import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const topComics = featuredComics.slice(0, 8);

  return (
    <section id="featured" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              <a href="#featured">热门推荐</a>
            </h2>
            <p className="text-foreground-500 text-sm">本周最受欢迎的漫画作品</p>
          </div>
          <Link
            to="/category/hanman"
            className="text-primary-500 hover:text-primary-600 text-sm font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {topComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 布丁漫画下拉式免费阅读`}
                  title={`${comic.title} 布丁漫画全集下拉式连续阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                    {index + 1}
                  </span>
                </div>
                {comic.status === '已完结' && (
                  <div className="absolute top-2 right-2">
                    <span className="bg-foreground-800/80 text-white text-xs px-2 py-0.5 rounded-full">
                      已完结
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-foreground-900 font-medium text-sm md:text-base truncate group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-foreground-500 text-xs">{comic.author}</span>
                <span className="text-foreground-400 text-xs">·</span>
                <span className="text-accent-500 text-xs flex items-center gap-0.5">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[10px]"></i>
                  </div>
                  {comic.rating}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}